import React, { useState, useMemo, useCallback, PropsWithChildren } from 'react';
import { SubscriptionConsentContext } from './context';
import { ConsentType } from './type';

export const SubscriptionConsentProvider = ({ children }: PropsWithChildren) => {
  const [email, setEmail] = useState<string>('');
  const [activateSecureEBox, setActivateSecureEBox] = useState<boolean>(false);
  const [consent, setConsent] = useState<ConsentType>({
    legal: false,
    marketing: false,
  });

  const handleSetEmail = useCallback((newEmail: string) => {
    setEmail(newEmail);
  }, []);

  const handleSetConsent = useCallback((newConsent: ConsentType) => {
    setConsent(newConsent);
  }, []);

  const handleSetActivateSecureEBox = useCallback((activate: boolean) => {
    setActivateSecureEBox(activate);
  }, []);

  const value = useMemo(
    () => ({
      email,
      consent,
      setEmail: handleSetEmail,
      setConsent: handleSetConsent,
      activateSecureEBox,
      handleSetActivateSecureEBox,
    }),
    [email, consent, handleSetEmail, handleSetConsent, activateSecureEBox, handleSetActivateSecureEBox]
  );

  return <SubscriptionConsentContext.Provider value={value}>{children}</SubscriptionConsentContext.Provider>;
};
